// Vuetify 2 initialization
import Vue from 'vue'
import Vuetify from "vuetify"

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md', //Material design icons
    },
});
